goog.provide("shadow.js.shim.module$$mui$material$Menu");
goog.provide("module$shadow_js_shim_module$$mui$material$Menu");
shadow.js.shim.module$$mui$material$Menu = shadow.js.nativeProvides["@mui/material/Menu"] = shadow$bridge("@mui/material/Menu");
module$shadow_js_shim_module$$mui$material$Menu.default = shadow.js.shim.module$$mui$material$Menu;
